class Webinars {
	static init() {
		$(".WebinarElement .vimeo-player").each((_index, iframe) => {
			var player = new Vimeo.Player(iframe);
			var vidTitle,
				vidUrl,
				vidDuration,
				quarterComplete = false,
				halfComplete = false,
				threeQuarterComplete = false;

			player.on('play', function(data) {
				var time = Math.round(data.seconds);
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					'event': 'gtm.video',
					'gtm.videoProvider': 'Vimeo',
					'gtm.videoStatus': 'start-'+time,
					'gtm.videoUrl': vidUrl,
					'gtm.videoTitle': vidTitle,
					'gtm.videoDuration': vidDuration,
					'gtm.videoCurrentTime': time,
					'gtm.videoVisible': true,
				});

			});

			player.getVideoTitle().then(function(title) {
				vidTitle = title;
			});
			player.getVideoUrl().then(function(url) {
				vidUrl = url;
			});
			player.getDuration().then(function(d) {
				vidDuration = d;
			});

			player.on('pause', function(data) {
				var time = Math.round(data.seconds);
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					'event': 'gtm.video',
					'gtm.videoProvider': 'Vimeo',
					'gtm.videoStatus': 'pause-'+time,
					'gtm.videoUrl': vidUrl,
					'gtm.videoTitle': vidTitle,
					'gtm.videoDuration': vidDuration,
					'gtm.videoCurrentTime': time,
					'gtm.videoVisible': true,
				});
			});

			player.on('ended', function(data) {
				var v = {Title:vidTitle, Duration:vidDuration, Url: vidUrl};
				pushProgress('100',vidDuration,v);
			});

			player.on('timeupdate', function(data) {
				var progress = Math.round(data.percent*100);
				var t = Math.round(data.seconds);
				var v = {Title:vidTitle, Duration:vidDuration, Url: vidUrl};
				switch (progress) {
					case 25:
						if (!quarterComplete) {pushProgress('25',t,v); quarterComplete=true;};
						break;
					case 50:
						if (!halfComplete) {pushProgress('50',t,v); halfComplete=true;};
						break;
					case 75:
						if (!threeQuarterComplete) {pushProgress('75',t,v); threeQuarterComplete=true;};
						break;
					default:

				}
			});
		});
	}
}